import { render, staticRenderFns } from "./AuDepart.vue?vue&type=template&id=53855f4b&"
import script from "./AuDepart.vue?vue&type=script&lang=js&"
export * from "./AuDepart.vue?vue&type=script&lang=js&"
import style0 from "./AuDepart.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
